import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from '../components/global/header';
import Footer from '../components/global/footer';
import VisitInfo from '../office/pages/Visits/info';
import VisitRecipes from '../office/pages/Visits/visitRecipes';
import BuyRecipes from '../office/common/buyRecipes';
import { getVisitByCode } from '../../api';
import { updateCity } from '../../actions';
import AppsList from '../components/global/footer/apps';

const CODE_RE = /^[a-zA-Z0-9]{8}$/;

function VisitByCode({ cities, updateCity }) {
  const { code } = useParams();
  const [visit, setVisit] = useState(null);
  const [city, setCity] = useState(null);
  const [status, setStatus] = useState('loading'); // loading | ok | 404 | 410 | error

  useEffect(() => {
    if (!CODE_RE.test(code)) {
      setStatus('404');
      return;
    }

    getVisitByCode(code)
      .then((response) => {
        const visitData = response.data;
        const cityId = visitData?.division?.city_id;
        const found = cities?.find((c) => c.id === cityId) ?? null;
        if (cityId && found) {
          updateCity({ ...found, position: { lat: +found.lat, lng: +found.lon } });
        }
        setVisit(visitData);
        setCity(found);
        setStatus('ok');
      })
      .catch((err) => {
        if (err?.status === 404) setStatus('404');
        else if (err?.status === 410) setStatus('410');
        else setStatus('error');
      });
  }, [code, cities]);

  return (
    <div>
      <Header city={city} />

      <main className="visit-by-code-page">
        <div className="container">
          {status === 'loading' && (
            <div className="visit-by-code-page__message">
              <i className="fas fa-spinner fa-spin visit-by-code-page__spinner" />
              <p>Завантаження...</p>
            </div>
          )}

          {status === '404' && (
            <div className="visit-by-code-page__message visit-by-code-page__message--error">
              <div className="visit-by-code-page__message-icon">
                <i className="fas fa-search" />
              </div>
              <h2>Візит не знайдено</h2>
              <p>Посилання недійсне</p>
            </div>
          )}

          {status === '410' && (
            <div className="visit-by-code-page__message visit-by-code-page__message--expired">
              <div className="visit-by-code-page__message-icon">
                <i className="fas fa-clock" />
              </div>
              <h2>Посилання застаріло</h2>
              <p>Термін дії посилання минув. Посилання дійсне протягом 24 годин після візиту.</p>
            </div>
          )}

          {status === 'error' && (
            <div className="visit-by-code-page__message visit-by-code-page__message--error">
              <div className="visit-by-code-page__message-icon">
                <i className="fas fa-exclamation-triangle" />
              </div>
              <h2>Помилка</h2>
              <p>Сталася помилка. Спробуйте оновити сторінку.</p>
            </div>
          )}

          {status === 'ok' && visit && (
            <div className="personal-visits-wrapper extended">
              <div className="personal-visits">
                <ul className="personal-visits-list">
                  <li className="personal-visits-list__item">
                    {visit.patient?.short_name && (
                      <div className="visit-by-code-page__greeting">
                        <p>Шановний(-а) {visit.patient.short_name}!</p>
                        <p>Результати Вашого візиту:</p>
                      </div>
                    )}
                    <VisitInfo
                      user={null}
                      date={visit.date}
                      division={visit.division}
                      doctor={visit.doctor}
                      diagnoses={visit.diagnoses}
                    />

                    {visit.promo_text && (
                      <div className="visit-by-code-page__pharm-text">
                        <div className="visit-by-code-page__pharm-text-icon">
                          <i className="fas fa-pills" />
                        </div>
                        <p className="visit-by-code-page__pharm-text-body" dangerouslySetInnerHTML={{ __html: visit.promo_text }} />
                      </div>
                    )}
                    
                    {visit.drugs?.length > 0 && <VisitRecipes drugs={visit.drugs} />}

                    <BuyRecipes buUrl={visit.buy_url} />
                  </li>
                </ul>
              </div>
              {!window.ReactNativeWebView && (
                <div className="app-promo-block">
                  <div className="app-market-search-row" role="presentation">
                    <img src="/favicon.ico" alt="Лікарі 24/7" className="app-market-search-row__icon" />
                    <div className="app-market-search-row__meta">
                      <div className="app-market-search-row__name">Лікарі 24/7</div>
                      <div className="app-market-search-row__company">ТОВ "СІЕТ Холдінг"</div>
                    </div>
                  </div>
                  <p className="app-promo-title">Рекомендуємо встановити наш застосунок</p>
                  <p className="app-promo-text">
                    Можливість перегляду Ваших медичних даних, статусу і результатів прийомів, отримуйте нагадування та сповіщення прямо на телефон.<br/>Рекомендуємо використовувати застосунок Likari 24/7.
                  </p>
                  <AppsList />
                </div>
              )}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

const mapStateToProps = ({ user }) => ({ cities: user.cities });

export default connect(mapStateToProps, { updateCity })(VisitByCode);
